import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { AlertService } from 'src/app/_services';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { FeedbackService } from '../../services/feedback.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent extends MaterialPage {

  submitted: boolean = false;

  contactForm = new FormGroup({
    message: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
  });

  constructor(
    breakpointObserver: BreakpointObserver,
    private feedbackService: FeedbackService,
    private alertService: AlertService,
    titleService: Title,
    meta: Meta,
    sidenavService: SidenavService,
    router: Router
  ) {
    super(
      breakpointObserver, 
      titleService, 
      meta,
      sidenavService,
      router,
      $localize `:page title:Contact us`,
      $localize `:page description:Your feedback is important to us. Help us build the secondhand marketplace of the future.`,
      true);
  }
  
  async submit() {
    
    if (!this.contactForm.valid) {
      return;
    }
    
    await this.feedbackService.save(this.contactForm.controls["message"].value!);
    this.alertService.showSuccess($localize `Thank you for your feedback!`);
    this.submitted = true;
  }
}
